// frontend/src/pages/platform/PlatformProtectedRoute.js
//
// Route guard for the superadmin console — the platform-side counterpart of
// pages/ProtectedRoute.js. Renders children only once PlatformAuthContext
// has validated a stored platform token (via /platform/me on mount);
// otherwise redirects to /platform/login.
import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { PlatformAuthContext } from '../../context/PlatformAuthContext';

export default function PlatformProtectedRoute({ children }) {
  const { admin, loading } = useContext(PlatformAuthContext);
  if (loading) {
    return (
      <div className="app-shell-root bg-slate-900 flex items-center justify-center text-slate-300">
        Loading…
      </div>
    );
  }
  if (!admin) {
    return <Navigate to="/platform/login" replace />;
  }
  return children;
}
